


export enum EFactoryProducts {
    Metal = "metal",
    Plasma = "plasma",
    EnergyCore = "energy_core",
    Energy = "energy",
    RepairKit = "repair_kit",
    BioGel = "biogel",
    EdibleBrick = "edible_briquette",
    OrganicMeat = "organic_meat",
}